// extracted by mini-css-extract-plugin
module.exports = {"container":"Ki-z","copy":"Li-z","field":"Mi-z","error":"Ni-z","disabled":"Oi-z","termsContainer":"Pi-z","termsHeading":"Qi-z","termsCopy":"Ri-z","submit":"Si-z","srOnly":"Ti-z"};